/* eslint camelcase: 0, no-unused-expressions: 0 */
/* global FB */

import React from 'react';
import PropTypes from 'prop-types';
import { FormBuilder } from '../forms/form';
import { Navbar } from '../navbar/navbar';
import { Profile } from 'api/api-profile';
import { Session } from 'api/api-user';
import { Helpers } from '../helpers/helpers';
import { PhoneNumberUtil } from 'google-libphonenumber'
import { SocialLoginButton } from '../buttons/social-button';
import appleConnect from '../flow-social/apple-signin';
import facebookCommon from '../flow-social/facebook-common';
import { TosCTAdisclaimer } from '../terms/cta-disclaimer';
import CheckboxField from '../reduxForms/fields/CheckboxField/CheckboxField';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Cookie from 'react-cookie';
import btoa from 'btoa';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import { getUserExperiences } from '../flow-login/assets/js/nux';
import googleCommon from '../flow-social/google-common';
import get from 'lodash/get';
import map from 'lodash/map';
import values from 'lodash/values';
import find from 'lodash/find';

import { Cloudinary } from '../../../../api/api-cloudinary';
import { SignupErrors, handleError } from '../nextjs/auth/signup/SignupManager/signup-errors';
import { InputError } from '../inputs/data/input-error';

class SignupForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      errorMsg: null,
      isSubmitting: false,
      googleLogin: false,
      retryCount: 0,
      maxRetries: 3,
      fbAccessTkn: ''
    };
    this.authWindowTick = null;

    this.signupAction = this.signupAction.bind(this);
    this.checkIfUserNeedsFacebookLogin = this.checkIfUserNeedsFacebookLogin.bind(this);
    this.signinCb = this.signinCb.bind(this);
    this.signupCb = this.signupCb.bind(this);
    this.fetchFacebookData = this.fetchFacebookData.bind(this);
    this.facebookLoginFn = this.facebookLoginFn.bind(this);
    this.clickAppleLoginFn = this.clickAppleLoginFn.bind(this);
    this.renderSignupFormBuilder = this.renderSignupFormBuilder.bind(this);
    this.fetchGoogleData = this.fetchGoogleData.bind(this);
    this.googleAuth = this.googleAuth.bind(this);
    this.createSocialUserCallback = this.createSocialUserCallback.bind(this);
    this.checkForCreateSocialErrors = this.checkForCreateSocialErrors.bind(this);
    this.navbarRefreshUserInfo = this.navbarRefreshUserInfo.bind(this);
    this.checkIfUserNeedsGoogleLogin = this.checkIfUserNeedsGoogleLogin.bind(this);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.handleInputOnChange = this.handleInputOnChange.bind(this);
    this.inputRefs = React.createRef();
    this.setEmailErrorState = this.setEmailErrorState.bind(this);
    this.retryLoginCB = this.retryLoginCB.bind(this);
    this.setErrorState = this.setErrorState.bind(this);
    this.errorMessages = defineMessages({
      error: {
        id: 'shared_components.signup_form.error',
        defaultMessage: 'An unexpected error occurred. Please try again in a few minutes.'
      },
      referesh_error: {
        id: 'shared_components.signup_form.refresh_error',
        defaultMessage: 'Something went wrong, please try again. If the problem persists please refresh.'
      },
    });
  }

  componentDidMount () {
    if (analyticsIntegrations) {
      analyticsIntegrations.whichModalOpened('Signup Modal');
    }
    if(this.props.showEmailErrors) {
      this.setEmailErrorState();
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.showEmailErrors !== this.props.showEmailErrors) {
      this.setEmailErrorState();
    }
  }

  componentWillUnmount () {
    clearInterval(this.authWindowTick);
  }

  setEmailErrorState () {
    // if an email user attempts to login with a social account
    // we want to highlight the email and password input field in red
    if (this.inputRefs && this.inputRefs.current) {
      const emailRef = this.inputRefs.current.formRefs['signupEmail'];
      const passRef = this.inputRefs.current.formRefs['signup_password'];

      const setInvalidState = (ref) => {
        ref.invalidState(InputError['password_no_msg'].error, []);
      };

      setInvalidState(emailRef);
      setInvalidState(passRef);
    }
  }

  redirectToLogin (res) {
    const loginType = Object.keys(res).find(key => res[key] === true);
    window.location.hash = `#a=login&type=${loginType}`;
  }

  signupAction (e, callback) {
    const username = $('#signup_email').val();
    const password = $('#signup_password').val();
    const emailOptOut = $('#email_opt_out').is(":checked");
    /* pre sign-up, regardless of other entitlements,
       we will attribute the tastemaker here
       if a user has been on their page */
    const promoId = this.props.entitlementId || PSSessions.Cookies('tm_ent') || PSSessions.Cookies('promo-id');
    const attrUrl = PSSessions.Cookies('PSAttrUrl');
    const attrRef = PSSessions.Cookies('PSAttrReferrer');
    const accessToken = PSSessions.Cookies('PSAccess');
    const forterToken = window.fcToken || PSSessions.Cookies('forterToken');
    const locale = Cookie.load('preferred_locale') || Cookie.load('initial_locale');

    // unsubscribe in vero will not work in alpha/beta due to a
    // segment alias call to vero that is only filtered out for prod
    const profileBody = {
      username,
      password,
      ga_client_id: analyticsIntegrations.getGoogleAnalyticsID(),
      attr_url: attrUrl,
      attr_referrer: attrRef,
      unsubscribe: emailOptOut,
      ...(locale && { preferred_locale: locale }),
      forterTokenCookie: forterToken
    };

    Cookie.save('preferred_locale', locale, {
      path: '/',
      expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
      domain: window.location.host,
      secure: -1 !== window.location.protocol.indexOf('s'),
    });

    this.setState({
      isSubmitting: true
    });

    if (promoId) profileBody.entitlement_id = promoId;

    Session.checkGrants(username, accessToken, (res) => {
      if (res.email) {
        this.setState({ isSubmitting: false });
        this.checkIfUserNeedsLogin(username, password);
      } else if (Helpers.userHasNoAccount(res)) {
        Profile.create(profileBody, callback.bind(this, username, password));
      } else {
        this.setState({ isSubmitting: false });
        return this.redirectToLogin(res);
      }
    });
  }

  trackLinkClick () {
    analyticsIntegrations.trackLinkClick('login link on sign up form');
  }

  userNameInUseError () {
    return (
      <p className="text-left">
        <FormattedMessage
          id="shared_components.signup_form.email_take"
          defaultMessage="This email is already taken."
        />&nbsp;
        <a href="#a=login" onClick={this.trackLinkClick}>
          <FormattedMessage
            id="shared_components.signup_form.login_link"
            defaultMessage="Login"
          />
        </a>
        &nbsp;
        <span className="text-gray-dark">
          <FormattedMessage
            id="shared_components.signup_form.or"
            defaultMessage="or"
          />
        </span>
          &nbsp;
        <a href="/app/password-reset">
          <FormattedMessage
            id="shared_components.signup_form.reset_password_link"
            defaultMessage="reset your password"
          />
        </a>
        <span className="text-gray-dark">.</span>
      </p>
    );
  }

  accountExistsError (loginType) {
    return (
      <span>
        <FormattedMessage
          id="shared_components.signup_form.account_exists"
          defaultMessage="This account already exists, please"
        />&nbsp;
        <a href="#a=login" onClick={this.trackLinkClick}>
          <FormattedMessage
            id="shared_components.signup_form.account_exists_login"
            defaultMessage="login"
          />
        </a>
        &nbsp;
        <span>
          <FormattedMessage
            id="shared_components.signup_form.account_exists_error"
            defaultMessage="with {loginType}."
            values={{
              loginType
            }}
          />
        </span>
      </span>
    );
  }

  checkIfUserNeedsFacebookLogin (email, id, socialToken) {
    Session.createSocial(email, 'facebook', id, socialToken, (res) => {
      this.setState({ fbAccessTkn: '' });
      this.signinCb(res, 'facebook');
    });
  }

  checkIfUserNeedsLogin (username, password) {
    Session.create(username, password, (res) => {
      if (res.error) {
        const errorDescription = get(res, 'error_description', '').length ? get(res, 'error_description', '') : get(res, 'error_description.message', '');
        return this.setState({ errorMsg: handleError(errorDescription || ''), isSubmitting: false });
      }
      return this.signinCb(res, null);
    });
  }

  checkIfUserNeedsGoogleLogin (email, id, socialToken) {
    Session.createSocial(email, 'google', id, socialToken, (res) => {
      this.setState({ googleLogin: false });
      this.signinCb(res, 'google');
    });
  }

  updateUserRWG (rwg, rwgExp, access) {
    Profile.update('me', access, { gmaps_booking: {
      rwg_token: rwg,
      exp: rwgExp
    } }, () => {});
  }

  signinCb (response, loginType) {
    const { intl } = this.props;
    if (response.facebook && !response.email) {
      return this.setState({
        errorMsg: intl.formatMessage(this.errorMessages.facebook_error),
        isSubmitting: false
      });
    }

    if (response.error) {
      let errorMsg = response.error_description;
      if (400 < response.statusCode || 'Invalid JSON' === errorMsg) {
        errorMsg = intl.formatMessage(this.errorMessages.error);
      } else {
        this.redirectToLogin(response);
      }
      this.setState({ errorMsg, isSubmitting: false });
    } else {
      if (window) {
        Helpers.setCookies(response);
      }

      if (PSSessions.Cookies('host-ref-promo')) {
        analyticsIntegrations.failedHostReferral(PSSessions.Cookies('host-ref-promo'));
        PSSessions.Cookies.expire('host-ref-promo');
        PSSessions.Cookies.expire('host-ref-promo-user-id');
      }

      // Render navbar
      if (loginType) {
        analyticsIntegrations.socialAccountLogin(loginType, loginType, response.SSOid);
      } else {
        analyticsIntegrations.accountLogin(response.SSOid);
      }

      const accessToken = btoa(response.access_token);
      const rwg = PSSessions.Cookies('rwg_val');
      const rwgExp = PSSessions.Cookies('rwg_exp');
      let shouldPersistRWG = !!rwg;
      Profile.read('/v1/profiles/me', accessToken, (profileResponse) => {
        const currentRWG = get(profileResponse, 'metadata.gmaps_booking.rwg_token');
        const currentRWGExp = get(profileResponse, 'metadata.gmaps_booking.exp');
        if (currentRWGExp && rwgExp) {
          shouldPersistRWG = currentRWGExp < rwgExp;
        }
        if (shouldPersistRWG) {
          this.updateUserRWG(rwg, rwgExp, accessToken);
        }
        let urlLocale;
        const envLocaleMap = SharedIntlProviderHOC.getEnvLocaleData();

        if (!profileResponse.error) {
          const preferredLocale = get(profileResponse, 'preferred_locale', '');
          urlLocale = get(envLocaleMap, `${preferredLocale}.url_prefix`,''); //Get url_locale based on the profile preferred_locale.

          Cookie.save('preferred_locale', preferredLocale, {
            path: '/',
            expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
            domain: window.location.host,
            secure: -1 !== window.location.protocol.indexOf('s'),
          });
        }

        getUserExperiences('name=terms&trigger=sign-in', accessToken, (res, nuxActionsObj) => {
          const nuxData = get(res, 'data', []);

          if (nuxData.length) {
            window.PSSessions.Cookies('turls', window.location.href);
            return nuxActionsObj.terms.action();
          }

          // unmount node
          this.setState({ show: false, userLoggedIn: true });

          //Get current window location
          var path = location.href.replace(location.origin,'').replace(location.hash,'');
          const pathPrefix = path.split('/')[1];

          if (pathPrefix !== urlLocale) { //if path prefix is not already the profile locale
            //Reload page
            const supportedUrlLocales = map(values(envLocaleMap),'url_prefix');

            //check path is not already prefixed with a url_locale. Remove if so
            if(supportedUrlLocales.includes(pathPrefix)){
              path = path.replace(`/${pathPrefix}`,'');
            }
            const redirectPath = `${urlLocale ? `/${urlLocale}` : ''}${path}`;

            if (redirectPath.replace(location.search, '') !== location.pathname) {
              // setup redirect url with new url_locale
              const redirectUrl = `${location.origin}${redirectPath}`;

              // reload window per profile preferred locale
              location.hash = "";
              location.href = redirectUrl;
            }
          }

          if (!this.props.isSignupPage) {
            Navbar.refreshUserInfo();
            this.props.closeFn();
          }

          if (this.props.loginCallbackFn) {
            this.props.loginCallbackFn(accessToken);
          }
        });
      });
    }
  }

  signupCb (username, password, response) {
    const rwg = PSSessions.Cookies('rwg_val');
    const rwgExp = PSSessions.Cookies('rwg_exp');
    const { isSignupPage, intl } = this.props;
    if (response.facebook) {
      return this.setState({
        errorMsg: intl.formatMessage(this.errorMessages.facebook_error),
        isSubmitting: false
      });
    }
    if (response.error) {
      let errorMsg = get(response, 'error_description', '');
      const statusCode = get(response, 'statusCode', 0);
      if (400 < statusCode || 'Invalid JSON' === errorMsg) {
        errorMsg = intl.formatMessage(this.errorMessages.error);
      } else if ('Username in use' === response.error_description) {
        errorMsg = '';
        this.checkIfUserNeedsLogin(username, password);
      }
      this.setState({ errorMsg, isSubmitting: false });
    } else {
      const rwg = PSSessions.Cookies('rwg_val');
      const rwgExp = PSSessions.Cookies('rwg_exp');

      if (window && response.SSOid) {
        Helpers.setCookies(response);
      }

      // if there was an rwg token value, update the profile
      if (rwg) {
        this.updateUserRWG(rwg, rwgExp, PSSessions.Cookies('PSAccess'));
      }
      // Render navbar & fire signup segment call using extraSignupAttrs
      if (!isSignupPage) {
        const extraSignupAttrs = {
          source: this.props.extraSignupAttrs.source,
          method: 'email'
        };
        Navbar.refreshUserInfo(true, true, extraSignupAttrs);
      }
      // Render profile modal
      this.props.callbackFn(response);
    }
  }

  retryLoginCB = () => {
    this.setState(
      prevState => ({ retryCount: prevState.retryCount + 1 }),
      () => this.facebookLoginFn()
    );
  }

  setErrorState = () => {
    this.setState({ errorMsg: Helpers.somethingWentWrongError(), isSubmitting: false });
  }

  fetchFacebookData (authRes) {
    const accessToken = PSSessions.Cookies('PSAccess');
    const { authResponse } = authRes;
    const socialToken = authResponse?.accessToken || this.state.fbAccessTkn || '';

    if (!authResponse) {
      return Helpers.retryLogin(this.state.retryCount, this.state.maxRetries, this.setErrorState, this.retryLoginCB);
    }

    this.setState({ fbAccessTkn: socialToken });

    facebookCommon.fetchData((res) => {
      if (res.error || !res) {
        Helpers.handleFacebookError(res, this.state.retryCount, this.state.maxRetries, this.facebookLoginFn, this.setErrorState);
        return;
      }

      this.setState({ socialProvider: 'facebook' });
      const { first_name, last_name, email, work, picture, id } = res;

      let experience;
      let organization;
      let job_title;
      let avatar;

      if (work && (0 < work.length)) {
        experience = work[0];
      }

      if (experience) {
        const { employer, position } = experience;

        employer && employer.name
          ? organization = employer.name
          : null;

        position && position.name
          ? job_title = position.name
          : null;
      }

      if (picture) {
        const { data } = picture;

        data && !data.is_silhouette
          ? avatar = `https://graph.facebook.com/${id}/picture?type=large&width=500&height=500`
          : null;
      }

      this.setState({
        prefilledData: {
          email,
          first_name,
          last_name,
          organization,
          job_title,
          avatar,
          fbId: id
        }
      });

      Session.checkGrants(email, accessToken, (response) => {
        // Username exists.
        if (response.email || response.google || response.apple) {
          // In the event that user is successfully authenticated with Facebook,
          // but has not signed up using Facebook with us
          // we want to log them out, so they can sign up try logging
          // in w/ a different facebook id. (or login)
          FB.logout((/* res */) => {
            this.setState({ isSubmitting: false });
            return this.redirectToLogin(response);
          });
        }

        // New User
        if (Helpers.userHasNoAccount(response)) {
          analyticsIntegrations.socialAccountFound('facebook', 'facebook');
          this.setState({ isSubmitting: false });
          this.props.facebookCallbackFn(res, this.state.prefilledData, socialToken);
        }
        // Existing Facebook user, attempt to sign them in.
        if (response.facebook) {
          this.checkIfUserNeedsFacebookLogin(email, id, socialToken);
        }
      }, { facebook: id });
    });
  }

  facebookLoginFn () {
    FB.getLoginStatus((res) => {
      facebookCommon.getStatusCallback(res, this.fetchFacebookData);
    });
  }

  clickAppleLoginFn () {
    const {
      intl,
      extraSignupAttrs: {
        source
      } = {}
    } = this.props;

    appleConnect.getCode('signup', source, (errorResponse) => {
      if (errorResponse.error) {
        this.setState({ appleErrorMessage: intl.formatMessage(this.errorMessages.apple_error), isSubmitting: false });
      }
    });
  }

  handleInputOnChange () {
    const fields = ['signupEmail', 'signup_password'];
    const hasError = fields.some(field => get(this.inputRefs, `current.formRefs["${field}"].state.error.inputBorder`, '') === 'error');
    if (hasError) {
      this.inputRefs.current.inputsValid();
    }
  }

  renderSignupFormBuilder () {
    const signupFormInputMetaData = [
      {
        inputFieldName: 'email',
        elementID: 'signup_email',
        optional: false,
        ref: 'signupEmail',
        hideRequired: true,
        colSize: this.props.useBootstrapGrid ? 'col-xs-12' : '',
        onChange: () => this.handleInputOnChange()
      },
      {
        inputFieldName: 'password',
        elementID: 'signup_password',
        optional: false,
        ref: 'signup_password',
        hideRequired: true,
        colSize: this.props.useBootstrapGrid ? 'col-xs-12' : '',
        onChange: () => this.handleInputOnChange()
      }
    ];
    return (
      <FormBuilder
        ref={this.inputRefs}
        useBootstrapGrid={this.props.useBootstrapGrid}
        ctaButtonAttributes={{ 'data-testing-id': 'signup-btn' }}
        formname="signup form"
        formStyle="standard"
        formInputs={signupFormInputMetaData}
        submitAction={this.signupAction}
        submitCallback={this.signupCb}
        isButtonDisabled={this.state.isSubmitting}
        buttonText={
          <FormattedMessage
            id="shared_components.signup_form.signup"
            defaultMessage="Sign Up"
          />
        }
        errorText={this.state.errorMsg || this.props.errorMsg}
        afterCTA={
          <div className="gutter margin-xl-bottom email-opt-out">
            <TosCTAdisclaimer buttonLabel={<FormattedMessage id="shared_components.signup_form.signup" defaultMessage="Sign Up" />} location="signup" />
            <hr className="full-width" />
            <p className="text-small text-center">
              <FormattedMessage
                id="shared_components.signup_form.email_opt_message"
                defaultMessage="Peerspace will send you deals, inspiration, and marketing emails. You can opt out at any time from your account settings."
              />
            </p>
            <CheckboxField
              id="email_opt_out"
              label={
                <div className="text-small">
                  <FormattedMessage
                    id="shared_components.signup_form.email_opt_checkbox"
                    defaultMessage="I don’t want to receive marketing emails from Peerspace."
                  />
                </div>
              }
              inputClassName="custom-control-input-small"
            />
          </div> }
      />
    );
  }

  googleAuth () {
    const authWindow = window.open();
    this.setState({ googleLogin: true })
    googleCommon.googleConnect('signup', (error, authUrl) => {
      if (error) {
        this.setState({
          errorMsg: <FormattedMessage id="shared_components.page_login.google_error" defaultMessage="Something went wrong. Please try again" />,
          googleLogin: false
        });
        authWindow.close();
        return;
      }
      // Clear interval for previously opened window
      this.setState({ errorMsg: '', socialProvider: 'google' });
      clearInterval(this.authWindowTick);

      // Open new window with Google oauth endpoint
      // And checking for closing new window for complete sign up flow
      if (!authWindow) {
        return this.setState({ errorMsg: handleError(), googleLogin: false });
      }
      authWindow.location = authUrl;
      this.authWindowTick = setInterval(() => {
        if (authWindow.closed) {
          clearInterval(this.authWindowTick);

          try {
            const userData = JSON.parse(PSSessions.Cookies('ps_g_user'));
            PSSessions.Cookies.expire('ps_g_user');
            this.fetchGoogleData(userData);
          } catch (err) {
            this.setState({
              googleLogin: false,
              errorMsg: <FormattedMessage id="shared_components.page_login.google_error" defaultMessage="Something went wrong. Please try again" />
            });
          }
        }
      }, 500);
    });
  }

  fetchGoogleData (userData) {
    const accessToken = PSSessions.Cookies('PSAccess');
    const socialToken = userData.accessToken;
    const {
      firstName,
      lastName,
      email,
      sub: id,
      peopleApiKey
    } = userData;

    googleCommon.fetchUserData(socialToken, peopleApiKey, (fetchResponse = {}) => {
      let avatar = '';
      let phone = '';
      let phoneCountryCode = '';
      let phoneCountry = '';
      const primaryPhoto = find(fetchResponse.photos, photo => get(photo, 'metadata.primary'));
      const primaryPhone = find(fetchResponse.phoneNumbers, phone => {
        return get(phone, 'metadata.primary') &&
          phone.type === 'mobile' &&
          phone.canonicalForm
      });

      if (primaryPhoto && !primaryPhoto.default) {
        avatar = get(primaryPhoto, 'url', '');
      }

      if (primaryPhone) {
        const canonicalPhoneNumber = get(primaryPhone, 'canonicalForm', '');
        const phoneUtil = PhoneNumberUtil.getInstance();
        const parsedPhone = phoneUtil.parse(canonicalPhoneNumber);

        phone = parsedPhone.getNationalNumber().toString();
        phoneCountryCode = parsedPhone.getCountryCode().toString();
        phoneCountry = phoneUtil.getRegionCodeForNumber(parsedPhone).toLowerCase();
      }

      const prefilledData = {
        email,
        first_name: firstName,
        last_name: lastName,
        avatar,
        phone,
        phone_country_code: phoneCountryCode,
        phone_country: phoneCountry,
      };

      this.setState({ prefilledData }, () => {
        Session.checkGrants(email, accessToken, grantsResponse => {
          if (Helpers.userHasNoAccount(grantsResponse)) {
            this.props.googleCallback(userData, this.state.prefilledData, socialToken, this.checkForCreateSocialErrors, this.createSocialUserCallback);
          } else if (grantsResponse.google) {
            this.setState({ isSubmitting: false });
            this.checkIfUserNeedsGoogleLogin(email, id, socialToken);
          } else {
            this.setState({ isSubmitting: false, googleLogin: false });
            return this.redirectToLogin(grantsResponse);
          }
        }, { google: id });
      });
    });
  }

  checkForCreateSocialErrors (response, callback) {
    if (response.error) {
      let errorMsg = response.error_description;

      if (400 < response.statusCode || 'Invalid JSON' === errorMsg) {
        errorMsg = <FormattedMessage id="shared_components.social_email_form.invalid_error" defaultMessage="An unexpected error occurred. Please try again in a few minutes."/>;
      } else if ('jwt expired' === errorMsg) {
        errorMsg = <FormattedMessage id="shared_components.social_email_form.expired_error" defaultMessage="Your sign up session has expired. Click the X to start over."/>;
      } else {
        this.redirectToLogin(response);
        return;
      }

      this.setState({ errorMsg, googleLogin: false });
    } else {
      callback(response);
    }
  }

  createSocialUserCallback (response) {
    const rwg = PSSessions.Cookies('rwg_val');
    const rwgExp = PSSessions.Cookies('rwg_exp');
    
    if (window) {
      Helpers.setCookies(response);
    }

    const accessToken = PSSessions.Cookies('PSAccess');
    const profileBody = {
      ...this.state.prefilledData
    };

    if (rwg) {
      profileBody.gmaps_booking = {
        rwg_token: rwg,
        exp: rwgExp
      };
    }

    Cloudinary.create(this.state.prefilledData.avatar, (err, cloudinaryResponse) => {
      if (!err) {
        const newProfileURL = cloudinaryResponse.length ? cloudinaryResponse[0].secure_url : cloudinaryResponse.secure_url;
        profileBody.avatar_url = newProfileURL.replace('upload/', 'upload/c_crop,g_custom/');
      }

      Profile.update('me', accessToken, profileBody, this.navbarRefreshUserInfo);
    });
  }

  navbarRefreshUserInfo () {
    const extraSignupAttrs = {
      method: this.state.socialProvider,
      source: this.props.source
    };
    Navbar.refreshUserInfo(true, true, extraSignupAttrs);
    this.props.closeFn();
  }

  render () {
    const hideGoogleButton = !window.googleSignUpActivated;
    return (
      <div>
        <SocialLoginButton
          clickFn={ this.googleAuth }
          isLoading={ this.state.googleLogin }
          imageAlt="google logo"
          imageSrc="google_logo.svg?v=rb"
          buttonText={
            <FormattedMessage
              id="shared_components.signup_form.google_signup"
              defaultMessage="Sign up with Google"
            />
          }
          buttonID="button-login-google"
          buttonClass="btn-social"
          hideButton={hideGoogleButton}
        />
        <SocialLoginButton
          clickFn={this.clickAppleLoginFn}
          errorMessage={this.state.appleErrorMessage}
          imageAlt="apple logo"
          imageSrc="apple_logo.svg?v=rb"
          buttonText={
            <FormattedMessage
              id="shared_components.signup_form.apple_signup"
              defaultMessage="Sign up with Apple"
            />
          }
          buttonID="button-login-apple"
          buttonClass="btn-social"
        />
        <SocialLoginButton
          clickFn={this.facebookLoginFn}
          divider
          errorMessage={this.state.facebookErrorMessage}
          imageAlt="facebook logo"
          imageSrc="facebook_logo.svg?v=rb"
          buttonText={
            <FormattedMessage
              id="shared_components.signup_form.fb_signup"
              defaultMessage="Sign up with Facebook"
            />
          }
          buttonID="button-login-facebook"
          buttonClass="btn-social"
        />
        {this.renderSignupFormBuilder()}
        {
          !this.props.hideSignIn &&
          <p className="text-small text-gray-darker text-center">
            <FormattedMessage
              id="shared_components.signup_form.already_have_account"
              defaultMessage="Already have an account?"
            />&nbsp;
            <a className="btn-link-secondary" onClick={this.trackLinkClick} href="#a=login">
              <FormattedMessage
                id="shared_components.signup_form.login_link"
                defaultMessage="Login"
              />
            </a>
          </p>
        }
      </div>
    );
  }
}

exports.SignupForm = injectIntl(SignupForm);

SignupForm.propTypes = {
  closeFn: PropTypes.func,
  callbackFn: PropTypes.func,
  facebookCallbackFn: PropTypes.func,
  extraSignupAttrs: PropTypes.object,
  hideSignIn: PropTypes.bool,
  loginCallbackFn: PropTypes.func,
  entitlementId: PropTypes.string,
  errorMsg: PropTypes.string,
  intl: PropTypes.object,
  googleCallback: PropTypes.func,
  useBootstrapGrid: PropTypes.bool,
  showEmailErrors: PropTypes.bool
};

SignupForm.defaultProps = {
  useBootstrapGrid: true,
  showEmailErrors: false
};
